import React, { useState } from 'react';

import { SecondaryButton } from '@magoosh/lib/button';
import { Form, Input } from '@magoosh/lib/forms';
import useAuthenticityToken from '@magoosh/utils/use_authenticity_token';
import { paths } from 'config/path_helpers';

interface Props {
  examVersion: string;
  planSlug: string;
  templateOptions: {
    estimatedLength: string;
    name: string;
    sectionId?: number;
    templateId: number;
  }[];
}

const TemplateOptionAndEmailForm: React.FC<Props> = (props) => {
  const authenticityToken = useAuthenticityToken();
  const [selectedTemplateOption, setSelectedTemplateOption] = useState(props.templateOptions[0]);

  return (
    <div>
      <div><strong>Choose Your Test</strong></div>

      <fieldset className="radio u-margin-A-n">
        {
          selectedTemplateOption && props.templateOptions.map((templateOption, idx) => {
            return (
              <div className="radio" key={idx}>
                <label>
                  <input
                    checked={selectedTemplateOption === templateOption}
                    name="templateOption"
                    onChange={() => { setSelectedTemplateOption(templateOption) }}
                    type="radio"
                    value={idx}
                  />
                  <span>
                    {templateOption.name}
                  </span>
                  <div className="text-gray-light" style={{ fontSize: 12 }}>Takes about {templateOption.estimatedLength}</div>
                </label>
              </div>
            )
          })
        }
      </fieldset>

      <form action={paths.guestAccess()} className="" method="get">
        <input type="hidden" name="authenticity_token" value={authenticityToken} />
        <input type="hidden" name="exam_version" value={props.examVersion} />
        <input type="hidden" name="slug" value={props.planSlug} />
        <input
          type="hidden"
          name="redirect_to"
          value={paths.practiceTestsQuickStart(selectedTemplateOption.templateId, selectedTemplateOption.sectionId)}
        />

        <div className="u-margin-B-m u-margin-T-xs" style={{ maxWidth: 400 }}>
          <Input name="email" label="Your Email Address" type="email" required />
        </div>

        <div className="d-flex">
          <SecondaryButton
            className="flex-1 flex-md-none"
            type="submit"
          >
            Start Your Practice Test
          </SecondaryButton>
        </div>
      </form>
    </div>
  );
};

export default TemplateOptionAndEmailForm;
